import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminLocationHeroes from "@/pages/admin/AdminLocationHeroes";

export const Route = createFileRoute("/admin/location-heroes")({
  head: () => pageHead("Admin \u2014 Location Heroes \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminLocationHeroes,
});
